module.exports = new __parcel__URL__("24791_h.cc07fe9c.jpg").toString();